import gql from 'graphql-tag'

// NOTE
export const RefreshChartsData = gql`
  query RefreshChartsData($patientId: ID!, $emrId: ID!, $emrDepartmentId: ID!, $encounterEmrId: ID!) {
    refreshChartsData(input: { patientSukiId: $patientId, patientEmrId: $emrId, appointmentDepartmentEmrId: $emrDepartmentId, encounterEmrId: $encounterEmrId }) {
      success
    }
  }
`
